import styled from "styled-components";

const Card = styled.button`
  /* width: ${({ theme }) => theme.fixedReqCardWidth}; */
  width:${({ theme }) =>
    !["xm"].includes(theme.windowWidth) ? theme.fixedReqCardWidth : '100%'};
  border-radius: 12px;
  border:1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.05);
  background-color: #ffffff;
  font-family: inherit;
  color: #353a50;
  padding: 6px 10px;
  text-align: right;
  margin-bottom: 30px;

  .city-head {
    font-weight: bold;
    font-size: 1em;
  }

  .city {
    opacity: 0.5;
    margin-right: 5px;
  }
  .req-type {
    width: 100%;
    margin: auto;
    height: 30px;
    border-radius: 8px;
    background-color: rgba(42, 46, 67, 0.1);
    margin-top: 9px;
    margin-bottom: 9px;
  }
  .load-desc {
    font-size: 0.85em;
    opacity: 0.5;
    margin-top: 6px;
    margin-bottom: 10px;
  }
  .custom-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
  }
  .custom-row > div {
    background: #f4f4f5;
    border-radius: 8px;
    width: 90px;
    height: 42px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
  }
  .custom-row > div:last-child {
    width: 60px;
  }
`;

const BtnStatus = styled.div`
  height: 30px;
  border-radius: 8px;
  width: 100%;
  font-weight: bold;
  color: white;
  background-color: blue;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ status }) => {
    switch (status) {
      case 0:
        return "#3278d7";
      case 1:
        return "#388ecd";
      case 2:
        return "#3da3c2";
      case 3:
        return "#43b9b8";
      case 4:
        return "#48cfad";
      case 5:
        return "#f6a742";
      case 10:
        return "#ed5565";

      default:
        return "gray";
    }
  }};
`;

export { Card, BtnStatus };
